module.exports = __webpack_public_path__ + "static/media/Spot-uvIcon.a5bc3c82.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/Spot-uvIcon.png
// module id = 1805
// module chunks = 0